// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

// action types
import {
  ASSIGN_PATH_DATA,
  PATH_DETAILS_ERROR,
  TOGGLE_PASSIVE_REPEATER_DISPLAY,
  UPDATE_PASSIVE_REPEATER_STORE,
} from './types'

import { initialState } from './initialValues'

const pathDetails = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_PATH_DATA :
      return state.merge(
        fromJS({
          ...action.pathInfo,
          comments: fromJS(action.comments),
        })
      )

    case PATH_DETAILS_ERROR :
      return state.merge(
        fromJS({
          error: action.error,
        })
      )

    case TOGGLE_PASSIVE_REPEATER_DISPLAY :
      return state.merge(
        fromJS({
          showPassiveRepeaters: !state.get('showPassiveRepeaters'),
        })
      )

    case UPDATE_PASSIVE_REPEATER_STORE :
      return state.merge(
        fromJS({
          passiveRepeatersStore: fromJS(action.p || []),
        })
      )

    default :
      return state
  }
}

export default pathDetails
